module.exports = __webpack_public_path__ + "public/StoreIcon/Uparrowwithcircle20x20.svg?36d6b53d";